import PropTypes from 'prop-types';

export const ScenarioPropType = PropTypes.shape({
  scenarioId: PropTypes.number,
  scenarioName: PropTypes.string,
  periodName: PropTypes.string,
  dataSource: PropTypes.string,
  sourceName: PropTypes.string,
  publicFlag: PropTypes.oneOf(['Y', 'N']),
  createdSso: PropTypes.string,
});

export const ReportFieldDefinitionPropType = PropTypes.shape({
  from: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
  label: PropTypes.string,
});

export const ScenarioOptionsPropType = PropTypes.arrayOf(PropTypes.shape({
  value: PropTypes.number,
  label: PropTypes.string,
}));

export const ScenarioListColumnState = PropTypes.shape({
  columns: PropTypes.arrayOf(PropTypes.object), // eslint-disable-line react/forbid-prop-types
  columnGroups: PropTypes.arrayOf(PropTypes.object), // eslint-disable-line react/forbid-prop-types
});

export const ScenarioMemberDataPropType = PropTypes.shape({
  CC_DESCRIPTION: PropTypes.string,
  COMPANY_CODE: PropTypes.string,
  COUNTRY_NAME: PropTypes.string,
  COUNTRY_TAX_TYPE: PropTypes.string,
  ETR: PropTypes.number,
  FUNCTIONAL_CURRENCY: PropTypes.string,
  IBT: PropTypes.number,
  TOTAL_TAX_EXPENSE: PropTypes.number,
});
